<script lang="ts">
	import BaseAdminLayout from './BaseAdminLayout.svelte';
	import type { User } from '$lib/shared/lib/types';

	interface Props {
		user: User | null;
		children?: import('svelte').Snippet;
	}

	let { user, children }: Props = $props();
</script>

<!-- Absolute header positioning for panel page to allow play controls at top -->
<BaseAdminLayout {user} headerAbsolute={true} mainFullHeight={true}>
	{@render children?.()}
</BaseAdminLayout>
